import styles from "./index.module.scss";
import React from "react";
import { type Config, type UseAccountReturnType } from "wagmi";
import { useModularPermissionsStore } from "@/features/mod-perms/stores/modular-permissions.store";
import ModPermsActionBtns from "@/features/mod-perms/components/buttons/action-btns";
import PermissionsCard from "@/features/mod-perms/components/cards/permissions-card/permissions-card";
import LoadingIndicatorCard from "@/features/mod-perms/components/cards/loading-card/loading-indicator-card";

type Props = {
  accountStatus: UseAccountReturnType<Config>;
};

const AddPermissionBlock = ({ accountStatus }: Props) => {
  const { isDelegateContextGranted, receivedPermissions } =
    useModularPermissionsStore();

  const addedDelegate = useModularPermissionsStore((state) =>
    state.delegatePermissions.find(
      (perm) => perm.delegate === state.socialDelegateQueryParams?.account,
    ),
  );

  const isConnected = accountStatus.isConnected;
  const isDelegateGranted = isDelegateContextGranted();
  const hasPermissions = receivedPermissions.length > 0;

  const showModPermsActionBtns =
    (isConnected && isDelegateGranted) ||
    (isConnected && !isDelegateGranted && hasPermissions);

  return (
    <div className={styles.sectionWrapper}>
      <div className={styles.createSocialTop}>
        <div className={styles.socialAccount}>
          <div className={styles.header}>Create your Blessed Account</div>
          <div>
            <p>1. Connect with the account you are delegating from</p>
            <p>2. Select the permissions you are delegating (default is all)</p>
            <p>3. Click Save changes</p>
          </div>
        </div>
        <ModPermsActionBtns hideLeftControls />
      </div>
      {addedDelegate ? (
        <PermissionsCard delegate={addedDelegate} hideExitBtn />
      ) : (
        <LoadingIndicatorCard />
      )}
    </div>
  );
};

export default AddPermissionBlock;
